import { showNoRepeatingConsole } from './show-no-repeating-console';

const text = {
  current: '',
};

export const getIsANTLRErrors = (from: string) => {
  let isANTLRErrors = process?.env?.ANTLR_ERRORS === 'true';

  if (typeof window !== 'undefined' && !isANTLRErrors) {
    const flagsmithState = window.__fss;
    isANTLRErrors = String(flagsmithState?.flags?.antlr_errors?.enabled) === 'true' || window.__env?.ANTLR_ERRORS === 'true';
  }

  if (isANTLRErrors) {
    showNoRepeatingConsole(text, `ANTLR_ERRORS from ${from} on.`);
  }
  else {
    showNoRepeatingConsole(text, `ANTLR_ERRORS from ${from} off.`);
  }

  return isANTLRErrors;
};
